import { useEffect } from 'react';

const HIDE_DELAY_MS = 2000;

// 스크롤 중에만 스크롤바를 보여주고, 정지 2초 후 숨긴다(html.is-scrolling 클래스 토글).
// 실제 시각 효과는 src/style/init.css 의 .is-scrolling 규칙에서 처리한다.
export function useScrollbarAutoHide() {
  useEffect(() => {
    const root = document.documentElement;
    let hideTimer;

    const handleScroll = () => {
      root.classList.add('is-scrolling');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        root.classList.remove('is-scrolling');
      }, HIDE_DELAY_MS);
    };

    // scroll 이벤트는 버블링되지 않으므로 캡처 단계에서 전역으로 수신한다.
    document.addEventListener('scroll', handleScroll, true);
    return () => {
      document.removeEventListener('scroll', handleScroll, true);
      clearTimeout(hideTimer);
      root.classList.remove('is-scrolling');
    };
  }, []);
}
